// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"be8dcddb","246":"93ad0ddd","365":"85975af1","426":"4f352751","458":"8e83042a","731":"17b10c80","787":"dfd6ef69"}[chunkId] + ".chunk.js";
};